// IDs aus der Adresse (?vorlage=, ?entwurf=, ?angebot=, ?kunde=, /kunden/:id) gehen in API-Pfade: nur echte UUIDs,
// sonst null (ein präparierter Link mit „..%2F“ träfe sonst andere /api-Pfade)
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const urlId = (v: string | null | undefined): string | null => (v && UUID.test(v) ? v : null);
